const SAFE_PATHS = new Set([
  '/',
  '/home',
  '/hub',
  '/universe',
  '/united-square',
  '/puzzle',
  '/online',
  '/ranking',
  '/rules',
  '/privacy',
  '/education',
])

export function isUpdateSafePath(pathname: string) {
  return SAFE_PATHS.has(pathname.replace(/\/$/, '') || '/')
}

export function canReloadForUpdate() {
  return (
    isUpdateSafePath(window.location.pathname) &&
    !Array.from(document.querySelectorAll('dialog[open], [role="dialog"]')).some(
      element => element.getClientRects().length > 0,
    )
  )
}

export function answerUpdateReadiness() {
  if (!('serviceWorker' in navigator)) return () => {}
  const listener = (event: MessageEvent) => {
    if (event.data?.type === 'US_PWA_SAFE_TO_UPDATE')
      event.ports[0]?.postMessage({ safe: canReloadForUpdate() })
  }
  navigator.serviceWorker.addEventListener('message', listener)
  return () => navigator.serviceWorker.removeEventListener('message', listener)
}

type UpdateResult = { ok: boolean; reason?: 'tabs' | 'busy' | 'unavailable' }

export function requestWaitingUpdate(worker: ServiceWorker): Promise<UpdateResult> {
  return new Promise(resolve => {
    const channel = new MessageChannel()
    const finish = (result: UpdateResult) => {
      clearTimeout(timeout)
      channel.port1.close()
      resolve(result)
    }
    const timeout = window.setTimeout(() => finish({ ok: false, reason: 'unavailable' }), 6000)
    channel.port1.onmessage = event =>
      finish(
        event.data?.ok === true
          ? { ok: true }
          : { ok: false, reason: event.data?.reason || 'unavailable' },
      )
    try {
      worker.postMessage({ type: 'SKIP_WAITING' }, [channel.port2])
    } catch {
      finish({ ok: false, reason: 'unavailable' })
    }
  })
}

export function reloadForUpdate() {
  window.location.reload()
}
